<template>
  <flat-pickr
    :value="value"
    class="form-control"
    :placeholder="placeholder"
    :config="mergedConfig"
    :tabindex="tabindex"
    :disabled="disabled"
    @input="$emit('input', $event)"
  />
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import { Turkish } from 'flatpickr/dist/l10n/tr.js';

export default {
  name: 'DatePicker',
  components: {
    flatPickr
  },
  props: {
    value: {
      type: [String, Date],
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    tabindex: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    mergedConfig() {
      const isTurkish = this.$i18n.locale === 'tr';
      const defaultAltFormat = this.config.enableTime ? 'd-m-Y H:i' : 'd-m-Y';
      const defaultDateFormat = this.config.enableTime ? 'Y-m-d H:i' : 'Y-m-d';

      return {
        locale: isTurkish ? Turkish : null,
        altInput: true,
        altFormat: defaultAltFormat,
        dateFormat: defaultDateFormat,
        time_24hr: true,
        ...this.config
      };
    }
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
